<template>
  <div v-if="permissions.hasRead">
    <app-detail-header :show-toggle="true"
      :show-new="false"
      :show-delete="false"
      :show-save="false"
      :show-print="false"
      :show-cancel="true"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <quote-template-side-menu />
        <quote-template-setting-menu
          @getQuoteTemplate="getQuoteTemplate" />
        <app-side-menu>
          <aside class="menu"
            slot="side-menu">
            <quote-template-tags
              :tags="tags"
              :tag-category-id="tagCategory.tagCategoryID"
              :selected-tags="selectedTagIDs"
              @toggle-tag="toggleTag" />
          </aside>
        </app-side-menu>
      </div>
      <div class="column m-3">
        <router-view />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="is-flex is-justify-content-center pt-5">
      <div class="notification is-danger is-flex is-size-4">
        You do not have permissions on this page
      </div>
    </div>
  </div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep'
import AppDetailHeader from '@/components/AppDetailHeader'
import { AppHeaderButtonTypes } from '@/enums'
import QuoteTemplateSideMenu from './QuoteTemplateSideMenu'
import QuoteTemplateSettingMenu from './QuoteTemplateSettingMenu'
import QuoteTemplateService from '@/services/QuoteTemplateService'
import StoreMixin from './storeMixin'
import QuoteTemplateRoutes from './route-types'
import QuoteTemplateTags from './QuoteTemplateTags.vue'
import AppSideMenu from '@/components/AppSideMenu'
import TagsService from '../manageTag/TagsService'
import { EventHubTypes } from '../../enums'

export default {
  name: 'QuoteTemplateView',
  components: {
    AppDetailHeader,
    QuoteTemplateSideMenu,
    QuoteTemplateSettingMenu,
    QuoteTemplateTags,
    AppSideMenu
  },
  mixins: [ StoreMixin ],
  props: {
  },
  data() {
    return {
      template: null,
      selectedTagIDs: [],
      tagCategory: {},
      tags: [],
      category: 'QuoteTemplate',
      originalTagIDs: []
    }
  },
  computed: {
    permissions() {
      return this.$user.permissions?.find(p => p.codeName == this.$route.meta.id) || null
    }
  },
  async created() {
    await this.getQuoteTemplate()
    this.checkSettingMenuConfig()
    await this.getTagsByCategory()
  },
  mounted(){
    this.$eventHub.$on(EventHubTypes.ReloadQuoteTemplate, () => {
      this.getTagsByCategory()
    })
  },
  methods: {
    cancel() {
      this.updateTemplateTags()
      this.flagNtarLtarItems(false)
      this.saveQuoteTemplate({ entity: null })
      this.$router.push(QuoteTemplateRoutes.QuoteTemplateListView.path)
    },
    checkSettingMenuConfig() {
      if (this.$route.meta.route == 'labour' && (!this.templateBodyId || !this.templateTimesType)) {
        // this.$toast.open({
        //   message: 'Please select labour times and body style first.',
        //   type: 'is-warning',
        //   duration: 3000
        // })
      this.$notification.openNotificationWithType('warning','','Please select labour times and body style first.',3000)

      }
    },
    async getQuoteTemplate() {
      this.template =
        await QuoteTemplateService.getQuoteTemplateByTemplateId(this.$route.params.entityId)

      if (this.template && Array.isArray(this.template.tags)) {
        this.selectedTagIDs = this.template.tags.map(tag => tag.tagID)
        this.originalTagIDs = [...this.selectedTagIDs]
      }
      this.saveQuoteTemplate({ entity: _cloneDeep(this.template) })
    },
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.Cancel:
          this.cancel()
          break
      }
    },
    toggleTag(tag) {
      const idx = this.selectedTagIDs.indexOf(tag.tagID)
      if (idx === -1) {
        this.selectedTagIDs.push(tag.tagID)
      } else {
        this.selectedTagIDs.splice(idx, 1)
      }
    },
    async getTagsByCategory() {
      this.tagCategory = await TagsService.getTagsByCategory(this.category)
      this.tags = this.tagCategory.tags || []
    },
    async updateTemplateTags() {
      const a = [...this.originalTagIDs].sort().join(',')
      const b = [...this.selectedTagIDs].sort().join(',')
      if (a !== b) {
        try {
          const result = await TagsService.updateAssetTags(this.template.templateId, this.selectedTagIDs)
          if (result.data === true) {
            this.$notification.openNotificationWithType('success','','Tags updated successfully.')
          } else {
            this.$notification.openNotificationWithType('danger','','Failed to update tags.')
          }
        } catch (e) {
            this.$notification.openNotificationWithType('danger','','Failed to update tags.')
        }
      }
    }
  }
}
</script>
